var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardano(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 375.02 346.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.81,172.01c-.8,13.9,9.9,25.8,23.8,26.6h1.5c14,0,25.3-11.3,25.2-25.3,0-14-11.3-25.3-25.3-25.2-13.4,0-24.5,10.5-25.2,23.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.61,165.51c-4.5-.3-8.4,3.2-8.6,7.7s3.2,8.4,7.7,8.6c4.5,.3,8.3-3.2,8.6-7.7,.3-4.5-3.2-8.3-7.7-8.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.21,25.41c4-2,5.6-7,3.6-11s-7-5.6-11-3.6-5.6,6.9-3.6,10.9c2,4.1,6.9,5.8,11,3.7-.1,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.81,70.11c6.2-3.1,8.7-10.7,5.6-16.9s-10.7-8.7-16.9-5.6-8.7,10.7-5.6,16.9c3.1,6.2,10.7,8.7,16.9,5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.61,100.81c4.8,3.1,11.2,1.8,14.4-3,3.1-4.8,1.8-11.2-3-14.4-4.8-3.1-11.2-1.8-14.4,3h0c-3.2,4.8-1.8,11.3,3,14.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.91,161.01c-7-.4-12.9,4.9-13.3,11.9s4.9,12.9,11.9,13.3c7,.4,12.9-4.9,13.3-11.9h0c.4-6.9-4.9-12.9-11.9-13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.01,245.71c-5.1,2.6-7.2,8.8-4.6,14,2.6,5.1,8.8,7.2,14,4.6,5.1-2.6,7.2-8.8,4.6-14h0c-2.6-5.1-8.9-7.2-14-4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.01,134.91c6.9,4.5,16.1,2.6,20.5-4.3,4.5-6.9,2.6-16.1-4.3-20.5-6.9-4.5-16.1-2.6-20.5,4.3-4.5,6.8-2.6,16,4.3,20.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.51,69.11c5.8,3.8,13.7,2.2,17.5-3.6s2.2-13.7-3.6-17.5c-5.8-3.8-13.7-2.2-17.5,3.6h0c-3.9,5.9-2.3,13.7,3.6,17.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.31,24.61c3.8,2.5,8.8,1.4,11.3-2.4s1.4-8.8-2.4-11.3-8.8-1.4-11.3,2.3c-2.4,3.8-1.3,8.9,2.4,11.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.41,147.91c-13.9-.8-25.9,9.9-26.6,23.8-.8,13.9,9.9,25.9,23.8,26.6h1.4c13.9,0,25.2-11.3,25.2-25.3,.1-13.3-10.4-24.4-23.8-25.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.11,133.11c4.3,8.5,13,13.9,22.6,13.9,13.9,0,25.2-11.3,25.2-25.3,0-3.9-.9-7.8-2.7-11.4-6.3-12.5-21.5-17.5-33.9-11.2-12.5,6.4-17.5,21.6-11.2,34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.01,100.81c5.1-2.6,7.1-8.9,4.5-14s-8.9-7.1-14-4.5-7.1,8.8-4.6,13.9c2.7,5.1,8.9,7.2,14.1,4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.01,108.81c-7.3,3.7-10.3,12.6-6.6,19.9,3.7,7.3,12.6,10.3,19.9,6.6s10.3-12.6,6.6-19.9-12.6-10.2-19.9-6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.51,20.81c5.7,.3,10.6-4.1,11-9.8S193.41,.41,187.71,.01c-5.7-.3-10.6,4-11,9.7-.3,5.8,4.1,10.7,9.8,11.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.41,86.11c8.2,.5,15.2-5.8,15.6-14,.5-8.2-5.8-15.2-14-15.6-8.2-.5-15.2,5.8-15.6,14-.4,8.2,5.8,15.2,14,15.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.01,237.71c7.3-3.7,10.3-12.6,6.6-19.9-3.7-7.3-12.6-10.3-19.9-6.6s-10.3,12.6-6.6,19.9c3.7,7.3,12.6,10.3,19.9,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.01,107.81c-7.6,11.7-4.4,27.3,7.3,34.9s27.3,4.4,34.9-7.3,4.4-27.3-7.3-34.9c-4.1-2.7-8.9-4.1-13.8-4.1-8.5,0-16.4,4.3-21.1,11.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.91,213.41c-6.3-12.5-21.5-17.5-33.9-11.2-12.5,6.3-17.5,21.5-11.2,33.9,6.3,12.5,21.5,17.5,33.9,11.2h0c12.4-6.2,17.5-21.2,11.3-33.7q0-.1-.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.01,211.61c-6.9-4.5-16.1-2.6-20.5,4.3-4.5,6.9-2.6,16.1,4.3,20.5,6.9,4.5,16.1,2.6,20.5-4.3,4.5-6.8,2.6-16-4.3-20.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.41,173.71c.4-7-4.9-12.9-11.9-13.3-7-.4-12.9,4.9-13.3,11.9s4.9,12.9,11.9,13.3h0c6.9,.4,12.9-5,13.3-11.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.31,164.71c-4.5-.3-8.4,3.2-8.6,7.7s3.2,8.4,7.7,8.6c4.5,.3,8.3-3.2,8.6-7.7,.2-4.5-3.2-8.3-7.7-8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334.41,245.71c-4.8-3.1-11.2-1.8-14.4,3-3.1,4.8-1.8,11.2,3,14.4,4.8,3.1,11.2,1.8,14.4-3,3.2-4.8,1.8-11.3-3-14.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.61,321.91c-3.8-2.5-8.8-1.4-11.3,2.3-2.5,3.8-1.4,8.8,2.3,11.3,3.8,2.5,8.8,1.4,11.3-2.3h0c2.6-3.7,1.5-8.8-2.3-11.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.81,321.11c-4,2-5.6,7-3.6,11s7,5.6,11,3.6,5.6-6.9,3.6-10.9c-2-4.1-6.9-5.8-11-3.7,.1,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.01,238.71c7.6-11.7,4.4-27.3-7.3-35-11.7-7.6-27.3-4.4-35,7.3s-4.4,27.3,7.3,35c4.1,2.7,8.9,4.1,13.8,4.1,8.6,.1,16.5-4.2,21.2-11.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.51,277.41c-5.8-3.8-13.7-2.2-17.5,3.6-3.8,5.8-2.2,13.7,3.6,17.5s13.7,2.2,17.5-3.6h0c3.9-5.8,2.3-13.7-3.6-17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.41,325.71c-5.7-.3-10.6,4.1-11,9.8s4.1,10.6,9.8,11c5.7,.3,10.6-4,11-9.7,.3-5.8-4.1-10.7-9.8-11.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.51,260.41c-8.2-.5-15.2,5.8-15.6,14-.5,8.2,5.8,15.2,14,15.6s15.2-5.8,15.6-14c.5-8.1-5.8-15.2-14-15.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.21,276.41c-6.2,3.2-8.7,10.8-5.5,17s10.8,8.7,17,5.5c6.2-3.1,8.7-10.7,5.6-16.9-3.2-6.2-10.8-8.8-17.1-5.6h0Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardano);
export default __webpack_public_path__ + "static/media/cardano.e0a93cb91b21855e8f083e93a48783aa.svg";
export { ForwardRef as ReactComponent };